import React, { useState } from 'react';
import { useLocation } from '@reach/router';
import { pushFormSubmissionDataLayer } from '_utils/misc';

import LeadPageSubscribeForm from '_components/LeadPageCommonForms/LeadPageSubscribeForm';
import LeadPageOwnerMileageForm from '_components/LeadPageCommonForms/LeadPageOwnerMileageForm';
import LeadPageFinishForm from '_components/LeadPageCommonForms/LeadPageFinishForm';
import { submitData } from '_components/LeadPageCommonForms/api';

import CarValuationOptionalInfoForm from './CarValuationOptionalInfoForm';
import CarValuationFirstStepForm from './CarValuationFirstStepForm';
import './style.less';

type Props = {
  title: string,
  serviceRequired: string,
  bigTitle?: string,
  focus?: boolean,
};

const LeadPageCarValuationForm = ({
  bigTitle,
  title,
  serviceRequired,
  focus,
}: Props) => {
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(1);
  const [token, setToken] = useState('');
  const [currentValues, setCurrentValues] = useState({});

  const onDoneStep1 = (token: string, values: Object) => {
    pushFormSubmissionDataLayer(location.pathname, values);
    setToken(token);
    setCurrentStep(2);
    setCurrentValues(values);
  };

  const onDoneStep2 = (token: string, values: Object) => {
    setToken(token);
    setCurrentStep(3);
    pushFormSubmissionDataLayer(`_step_2_${location.pathname}`, {...currentValues, ...values, token});
  };

  const onDoneStep3 = (token: string) => {
    setToken(token);
    setCurrentStep(4);
  };

  const onDoneStep4 = (token: string) => {
    setToken(token);
    setCurrentStep(5); //finish
  };

  if (currentStep === 1) {
    return (
      <CarValuationFirstStepForm
        submitData={(data) => submitData(data, 1, token, 'car-valuation')}
        bigTitle={bigTitle}
        title={title}
        serviceRequired={serviceRequired}
        onDone={onDoneStep1}
        focus={focus}
      />
    );
  }

  if (currentStep === 2) {
    return (
      <LeadPageOwnerMileageForm
        submitData={(data) => submitData(data, 2, token, 'car-valuation')}
        onDone={onDoneStep2}
        currentValues={currentValues}
      />
    );
  }

  if (currentStep === 3) {
    return (
      <CarValuationOptionalInfoForm
        token={token}
        onDone={onDoneStep3}
        currentValues={currentValues}
      />
    );
  }

  if (currentStep === 4) {
    return (
      <LeadPageSubscribeForm
        submitData={(data) => submitData(data, 4, token, 'car-valuation')}
        onDone={onDoneStep4}
      />
    );
  }

  return <LeadPageFinishForm />;
};

export default LeadPageCarValuationForm;
